// angular
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// services
import { CommentsService } from '@app/core/shared/services/comments.service';
// interfaces & env
import { ICommentData } from '@app/shared/interfaces/comment.interface';
import { environment } from '@environments/environment';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-comment-box',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    TranslateModule,
    TranslateDataPipe,
    ImageSourcePipe,
  ],
  templateUrl: './comment-box.component.html',
  styleUrl: './comment-box.component.scss',
})
export class CommentBoxComponent {
  public baseUrl: string = environment.baseUrl.base;

  // inputs
  comment = input.required<ICommentData>();
  isReplay = input<boolean>();

  // dependencies
  private readonly _commentsService = inject(CommentsService);

  constructor() {}

  // on replay functionality
  public onReplay() {
    const commentReplay = {
      id: this.comment()._id,
      user: `${this.comment()?.user?.first_name} ${
        this.comment()?.user?.last_name
      }`,
    };
    // set comment replay
    this._commentsService.commentReplay.set(commentReplay);
  }
}
